$(document).ready(function () {
    $("#import_transfer").on('click', function (e) {
        e.preventDefault()
        $("#modal-import-transfer").modal('show')
    })


    $("#form-import-transfer").on('submit', function (e) {
        e.preventDefault()
        const formData = new FormData($('#form-import-transfer')[0]);
        let route = "transfer-import";
        $.ajax({
            url: route,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                $('#btn-import-transfer').prop('disabled', true).text('Importando...');
            },
            success: function (response) {
                alertWithBtn(response.mensaje)
                location.reload()
                $('#modal-import-transfer').modal('hide');

            },
            error: function (xhr) {
                const errores = xhr.responseJSON?.errors;
                if (errores) {
                    alert(Object.values(errores).flat().join('\n'));
                } else {
                    alert('Ocurrió un error al importar.');
                }
            },
            complete: function () {
                $('#btn-import-transfer').prop('disabled', false).html('<i class="fas fa-file-import mr-1"></i> Importar');
            }
        });
    })

    $('#btn-import-transfer-sx').on('click', function () {

    });

    $(".form-add-article").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)

        $.ajax({
            url: "/add-item",
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {

            },
            success: function (response) {

                if (response.success) {
                    document.getElementById('div-table-detail-transfer').innerHTML = response.view;

                    alertWithBtn(response.msg)
                    return
                }
                alertError(response.msg)

            },
            error: function (xhr) {
                const errores = xhr.responseJSON?.errors;
                if (errores) {
                    alert(Object.values(errores).flat().join('\n'));
                } else {
                    alert('Ocurrió un error al importar.');
                }
            },
            complete: function () {
                $('#btn-import-transfer').prop('disabled', false).html('<i class="fas fa-file-import mr-1"></i> Importar');
            }
        });
    })

    $(".btn-corporativo-delete").on('click', function (e) {
        e.preventDefault()
        let uuid = $(this).data('uuid')
        let data = new FormData()
        data.append('uuid', uuid)
        $.ajax({
            url: "/get-box-for-transfer",
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {

            },
            success: function (response) {
                console.log(response);
                let select = $("#box-number");
                select.empty();
                select.append(
                    '<option value="">Seleccione una caja</option>'
                );
                $.each(response, function (index, boxNumber) {

                    select.append(
                        `<option value="${boxNumber}">
                    Caja ${boxNumber}
                </option>`
                    );

                });
            }
        })

        $("#modal-delete-item").modal('show')
    })

    $('#box-number').on('change', function () {
        let box = $(this).val();
        if (box) {
            let data = new FormData()
            data.append('box', box)
            data.append('transfer_uuid', $('#transfer_uuid').val())
            sendData(data)
        }
    });

    function sendData(data) {
        $.ajax({
            url: "/find-items-for-box",
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {

            },
            success: function(response) {
                console.log(response)
                if (response.success) {

                    let $select = $('#item_select');
                    let $quantitySelect = $('#quantity_select');

                    // Limpiar opciones anteriores
                    $select.empty();
                    $quantitySelect.empty();

                    // Opción inicial
                    $select.append(
                        '<option value="">Selecciona un artículo</option>'
                    );

                    $quantitySelect.append(
                        '<option value="">Selecciona una cantidad</option>'
                    );

                    response.items.forEach(function(item) {

                        let detail = item.box_detail_transfer_detail?.[0] ?? {};

                        $select.append(`
                <option value="${item.item_code}"
                        data-item-code="${item.item_code}"
                        data-quantity="${item.quantity}">
                    ${item.item_code} - ${detail.description ?? ''}
                </option>
            `);
                    });

                }
            }

        });
    }

    $('#item_select').on('change', function() {

        let quantity = parseInt(
            $(this).find(':selected').data('quantity')
        );

        let $quantitySelect = $('#quantity_select');

        $quantitySelect.empty();

        $quantitySelect.append(
            '<option value="">Selecciona una cantidad</option>'
        );

        if (!quantity || quantity < 1) {
            return;
        }

        // Crear opciones del 1 hasta quantity
        for (let i = 1; i <= quantity; i++) {
            $quantitySelect.append(
                `<option value="${i}">${i}</option>`
            );
        }
    });


    $(".form-print-transfer").on('submit', function (e) {

        e.preventDefault();

        let uuid = $(this).find('input[name="uuid"]').val();

        let iframe = document.getElementById('printFrame');
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.id = 'printFrame';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }

        // Cargar la vista en el iframe
        iframe.src = '/print-transfer?uuid=' + uuid;

        // Cuando cargue, imprimir
        iframe.onload = function () {
            iframe.contentWindow.print();
        };
    })

    $("#form-delete-item").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        $.ajax({
            url: "/remove-items-in-box",
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {

            },
            success: function(response) {
                if (response.success) {
                    location.reload()
                }
            }

        });
    })

    $(".open-modal-incidence").on('click', function (e) {
        e.preventDefault()
        let uuid = $("#transfer_uuid").val()
        let return_uuid = $("#return_uuid").val()
        let warehouse_code = $(this).data('warehouse_code')
        let item_code = $(this).data('item_code')
        let description = $(this).data('description')
        let data = new FormData()
        let incidence = $(this).data('incidence')

        data.append('uuid', uuid)
        data.append('item_code', item_code)
        data.append('return_uuid', return_uuid)
        data.append('warehouse_code', warehouse_code)
        $.ajax({
            url: "/obtain-the-missing-elements",
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {

            },
            success: function(response) {
                let $quantitySelect = $('.quantity-incidence');
                let quantity = response.quantity

                $(".span_item_code").html(item_code)
                $(".span_description").html(description)
                $("#item_code").val(item_code)


                $quantitySelect.empty();
                $quantitySelect.append(
                    '<option value="">Selecciona una cantidad</option>'
                );

                if (!quantity || quantity < 1) {
                    $quantitySelect.append(
                        '<option value="">Sin articulos disponibles</option>'
                    );
                }else{
                    // Crear opciones del 1 hasta quantity
                    for (let i = 1; i <= quantity; i++) {
                        $quantitySelect.append(
                            `<option value="${i}">${i}</option>`
                        );
                    }
                }

                let $tbody = $('#incidence-table-body');
                $tbody.empty();

                incidence.forEach(function(item) {
                    let format_date = formatDate(item.created_at);
                    $tbody.append(`
                <tr>
                <td>${item.item_code}</td>
                <td>${item.description}</td>
                <td>${item.quantity}</td>
                <td>${item.warehouse_code}</td>
                <td>${item.user_name}</td>
                <td>${format_date}</td>
            </tr>
        `);
                })




                $("#modal-incidence").modal('show')
            }



        });
    })

    $(".form-incidence").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        $.ajax({
            url: "/add-incidence",
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function(response) {
                console.log(response)
                location.reload()
            }
        })
    })

    function formatDate(date) {
        return new Date(date).toLocaleString('es-MX', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
})
